import { db }  from '../firebase'
import { collection, query, where, getDocs, getDoc, onSnapshot, orderBy, startAt, endAt, limit, doc, setDoc, addDoc, documentId, getCountFromServer } from "firebase/firestore";

export default class BaseModel {
    static data_name; // Firestore table name must be defined in subclass

    // let document_id; name of document assigned to document_id


    // Queries

    static async get(id) {
        const doc = await getDoc(this.documentRef(id));
        return this.instanceFromDocument(doc);
    }

    static async getBy(field, value){
        let results = await this.where(field, '==', value, 1);
        return results.length > 0 ? results[0] : null;
    }

    static async getForDocumentIDs(document_ids) {
        const q = query(this.collectionRef, where(documentId(),'in', document_ids));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }

    static async exists(id) {
        const doc = await getDoc(this.documentRef(id));
        return doc.exists();
    }



    static async all(page_size = 1000) {
        const q = query(this.collectionRef, limit(page_size));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }

    static async page(order_by, start_at = null, page_size = 100) {
        const q = query(this.collectionRef, orderBy(order_by), startAt(start_at), limit(page_size));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }

    // Usage: where('age', '>=', 18)
    // Valid Operators: '<' | '<=' | '==' | '!=' | '>=' | '>' | 'array-contains' | 'in' | 'array-contains-any' | 'not-in';
    static async where(fieldPath, opStr, value, results_limit = 1000) {
        const q = query(this.collectionRef, where(fieldPath, opStr, value), limit(results_limit));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }

    // Usage: whereAnd(['age', '>=', 18], ['gender', '==', 'female')
    // Valid Operators: '<' | '<=' | '==' | '!=' | '>=' | '>' | 'array-contains' | 'in' | 'array-contains-any' | 'not-in';
    static async whereAnd(...paramArray) {
        const whereParams = paramArray.map( params => where(params[0], params[1], params[2]))
        const q = query(this.collectionRef, ...whereParams);
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }


    static async startWithText(fieldPath, value, results_limit = 1000) {
        const q = query(this.collectionRef,
                        orderBy(fieldPath),
                        startAt(value),
                        endAt(value + "~"),
                        limit(results_limit));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }

    static async count (fieldPath, opStr, value) {
        const q = query(this.collectionRef, where(fieldPath, opStr, value));
        const snapshot = await getCountFromServer(q);
        return snapshot.data().count;
    }

    // Usage: onCollectionUpdate(documents => { for(let doc of documents) console.log("doc", doc) }, ['age', '>=', 18], ['gender', '==', 'female'])
    // Valid Operators: '<' | '<=' | '==' | '!=' | '>=' | '>' | 'array-contains' | 'in' | 'array-contains-any' | 'not-in';
    static onCollectionUpdate(listener, ...paramArray){
        const whereParams = paramArray.map( params => where(params[0], params[1], params[2]))
        const q = query(this.collectionRef, ...whereParams);
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            listener(querySnapshot.docs.map(doc => this.instanceFromDocument(doc)));
        });
        return unsubscribe;
    }

    // Usage: onDocumentUpdate(documents => { for(let doc of documents) console.log("doc", doc) }, ['age', '>=', 18], ['gender', '==', 'female'])
    // Valid Operators: '<' | '<=' | '==' | '!=' | '>=' | '>' | 'array-contains' | 'in' | 'array-contains-any' | 'not-in';
    static onDocumentUpdate(id, listener){
        const unsubscribe = onSnapshot(this.documentRef(id), doc => {
            listener(this.instanceFromDocument(doc));
        });
        return unsubscribe;
    }

    // Static Utils

    static documentRef(id){
        return doc(db, this.data_name, id);
    }

    static get collectionRef(){
        return collection(db, this.data_name);
    }

    static async getInstances(q){
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => this.instanceFromDocument(doc));
    }

    static instanceFromDocument(doc){
        if(doc.exists()){
            let instance = new this();
            Object.assign(instance, doc.data());
            instance.document_id = doc.id;
            return instance;
        }else{
            return null;
        }
    }



    // Instance Methods

    async save(overwrite = false){
        if(this.document_id){
            return await setDoc(this.docRef, this.toFirebaseDocument(), { merge: !overwrite });
        } else {
            let documentRef = await addDoc(this.constructor.collectionRef, this.toFirebaseDocument());
            this.document_id = documentRef.id;
            return documentRef;
        }
    }

    // await model.updateField({ some_field: true });
    async updateField(field_and_value){
        if(this.document_id){
            return await setDoc(this.docRef, field_and_value, { merge: true });
        }else{
            throw Error("updateField document doesn't exist")
        }
    }

    get docRef(){
        return doc(db, this.constructor.data_name, this.document_id)
    }

    toFirebaseDocument(){
        const { document_id, ...without_document_id } = Object.assign({}, this);
        return without_document_id;
    }
}
